/** Generic data ports accept every value type; flow ports only connect to flow. */
export function areBehaviorPortTypesCompatible(
  source: string,
  target: string,
): boolean {
  if (source === "flow" || target === "flow") return source === target;
  return source === target || source === "any" || target === "any";
}
